const loadingLabel = "Lade";
const deLU = {
  loadingLabel
};
export {
  deLU as default,
  loadingLabel
};
